import { http } from "./httpServices";
import { CUSTOMER, HOMEPAGE, OUTLET, PRODUCT } from "./constants";

export function fetchAllParks() {
  return http.get(`${OUTLET}${HOMEPAGE}`, {
    params: {
      page: 1,
      limit: 50,
      type: "parks",
      isActive: true,
    },
  });
}

export function fetchProductsOfParks(shortName, date) {
  return http.get(`${PRODUCT}${CUSTOMER}`, {
    params: {
      category: shortName === "winter" ? "lww_tickets" : shortName,
      shortName,
      date,
    },
  });
}
